import { useCallback, useState } from "react";
import { login } from "./authService";

export type SocialProvider = "Google" | "Microsoft" | "Apple";

/**
 * Starts the external OAuth flow (Google / Microsoft / Apple) and exposes its
 * loading / error state. Shared by the sign-in and sign-up forms.
 */
export const useSocialLogin = () => {
  const [socialLoading, setSocialLoading] = useState<boolean>(false);
  const [socialError, setSocialError] = useState<string | null>(null);

  const loginWithProvider = useCallback(async (provider: SocialProvider) => {
    setSocialLoading(true);
    setSocialError(null);

    try {
      await login(provider);
      // The browser is about to navigate away; keep the spinner briefly in
      // case the redirect is slow, then release the buttons.
      setTimeout(() => setSocialLoading(false), 1000);
    } catch (error) {
      setSocialLoading(false);
      setSocialError(error instanceof Error ? error.message : String(error));
    }
  }, []);

  return { socialLoading, socialError, loginWithProvider };
};
